/* eslint class-methods-use-this: 0, no-param-reassign: 0 */
import CollectionModule from 'client/store/modules/CollectionModule';
import DefaultPolicyGroupTemplatesApi from 'client/api/v2/DefaultPolicyGroupTemplatesApi';

export class DefaultPolicyGroupTemplateCollectionClass extends CollectionModule {}
export default new DefaultPolicyGroupTemplateCollectionClass(DefaultPolicyGroupTemplatesApi, 'name', 'name').extractModule();
